import type { LiquiditySeries } from "@kundeninfo/api-client";
import { readChoice, readJson, rememberValue, userKey } from "../../browserMemory.js";
import { GRANULARITIES } from "./liquidityModel.js";

type Granularity = LiquiditySeries["granularity"];

const GRANULARITY_KEY = "ki-liquidity-granularity";
const SCENARIO_KEY = "ki-liquidity-scenario";

/** Die gemerkte Verdichtung; Vorgabe Woche am Desktop, Monat am Telefon (Spec „Werkzeugleiste“). */
export function readGranularity(userId: string | undefined, phone: boolean): Granularity {
  return readChoice(userKey(GRANULARITY_KEY, userId), GRANULARITIES, phone ? "MONTH" : "WEEK");
}

export function rememberGranularity(userId: string | undefined, g: Granularity): void {
  rememberValue(userKey(GRANULARITY_KEY, userId), g);
}

/** Das gemerkte Szenario je Unternehmen, ein JSON-Objekt unter `ki-liquidity-scenario:<userId>`; Fremdes gilt als leer. */
function scenarios(userId: string | undefined): Record<string, unknown> {
  const raw = readJson(userKey(SCENARIO_KEY, userId));
  return typeof raw === "object" && raw !== null && !Array.isArray(raw) ? raw as Record<string, unknown> : {};
}

export function readScenario(userId: string | undefined, companyId: string): string | null {
  const id = scenarios(userId)[companyId];
  return typeof id === "string" ? id : null;
}

export function rememberScenario(userId: string | undefined, companyId: string, scenarioId: string | null): void {
  const { [companyId]: _old, ...others } = scenarios(userId);
  rememberValue(userKey(SCENARIO_KEY, userId), JSON.stringify(scenarioId === null ? others : { ...others, [companyId]: scenarioId }));
}
